import { useEffect } from 'react'
import Dropdown from '@/components/Dropdown/index'
import PropTypes from 'prop-types'

const CellDynamicSelectComponent = ({
  isReadOnly,
  payload,
  parentProps,
  inputProps,
  setInputProps,
  getFieldValue,
}) => {
  useEffect(() => {
    setInputProps({
      ...inputProps,
      disabled: isReadOnly,
      value: getFieldValue(payload, parentProps),
    })
  }, [payload])

  return (
    <Dropdown placeholder={null} value={inputProps?.value ?? ''} disabled={isReadOnly}>
      {[]}
    </Dropdown>
  )
}

CellDynamicSelectComponent.propTypes = {
  isReadOnly: PropTypes.bool,
  payload: PropTypes.object,
  parentProps: PropTypes.array,
  inputProps: PropTypes.object,
  setInputProps: PropTypes.func,
  getFieldValue: PropTypes.func,
}

export default CellDynamicSelectComponent
